import { styled } from 'styled-components';
import { COMMON_COLORS } from '@neteera/neteera-web-nextgen';

export const StyledTimeFrame = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  font-weight: 500;
  font-size: 12px;
  leading-trim: Cap height;
  line-height: 130%;
  letter-spacing: 0%;
  color: ${COMMON_COLORS.teal500};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const StyledRow = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const StyledHr = styled.hr`
  margin: 0 -16px;
`;

export const LegendWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  padding-top: 15px;
`;

export const LegendItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 11px;
  margin-left: 4px;
  margin-right: 17px;
  font-weight: 400;
  line-height: 140%;
  font-size: 14px;
  color: ${COMMON_COLORS.greyDark};
`;
